import axios from 'axios'
import store from '../store'
/* import { useToast } from 'vue-toastification'

const toast = useToast() */

const sgccApi = axios.create({
    baseURL: `${process.env.VUE_APP_API_URL}`,
    withCredentials: true,
})

sgccApi.interceptors.response.use(
    response => response,
    async error => {
        const originalRequest = error.config;
        const idToken = localStorage.getItem('idToken')
        
        if (error.response.status === 401 && !originalRequest._retry && idToken) {
            originalRequest._retry = true;

            try {
                const { ok, message } = await store.dispatch('auth/refreshToken');
                if (!ok) { 
                    store.commit("general/setToast", 
                    { 
                        severity: 'error', 
                        summary: 'ALERTA', 
                        detail: message
                    })
                }
                return sgccApi(originalRequest);
            } catch (refreshError) {
                store.commit("general/setToast", 
                { 
                    severity: 'error', 
                    summary: 'ALERTA', 
                    detail: 'SESIÓN CADUCADA'
                })
                await store.dispatch('auth/logout');
                return Promise.reject(refreshError);
            }
        }

        return Promise.reject(error);
    }
);


export default sgccApi